import React from "react";
import { UiTable } from "../../../components/common/UiTable";
import Avatar from '../../../../../styles/img/Avatar.png';
import { UiCardTitle } from "../../../components/common/UiCardTitle";

export const TeamMemberOverviewTable = () => {

    const TableHeaders = [

        { id: 1, th: 'Name' },
        { id: 2, th: 'Progress' },
        { id: 3, th: 'Option' }
    ];


    return (
        <>
            <div className="sb-goal-team-overview-table">
                <UiCardTitle title="Team Member Overview" />
                <div className="sb-goal-team-overview-table__wrapper">
                    <UiTable className="sb-white-bg-table sb-manager-tbl" tableHeader={TableHeaders}>
                        <tr>
                            <td>
                                <div>
                                    <img src={Avatar} />
                                    <span>
                                        <h4>Brad Simmons</h4>
                                        <p>Lorem Epsum</p>
                                    </span>

                                </div>
                            </td>
                            <td>
                                <div className="sb-prog-tbl">
                                    <div className="sb-prog-tbl__progress-amt" style={{ 'width': '50%' }}>
                                        <p>500 Points</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>Remove?</div>
                            </td>
                        </tr>


                        <tr className="active">
                            <td>
                                <div>
                                    <img src={Avatar} />
                                    <span>
                                        <h4>You</h4>
                                        <p>Lorem Epsum</p>
                                    </span>

                                </div>
                            </td>
                            <td>
                                <div className="sb-prog-tbl">
                                    <div className="sb-prog-tbl__progress-amt" style={{ 'width': '20%' }}>
                                        <p>200 Points</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                {/* <div>Remove?</div> */}
                            </td>
                        </tr>



                        <tr>
                            <td>
                                <div>
                                    <img src={Avatar} />
                                    <span>
                                        <h4>Brad Simmons</h4>
                                        <p>Lorem Epsum</p>
                                    </span>

                                </div>
                            </td>
                            <td>
                                <div className="sb-prog-tbl">
                                    <div className="sb-prog-tbl__progress-amt" style={{ 'width': '70%' }}>
                                        <p>700 Points</p>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div>Remove?</div>
                            </td>
                        </tr>




                    </UiTable>
                </div>
            </div>
        </>
    )
}